/**
 * Centralized API Configuration
 *
 * This file serves as the single source of truth for all API endpoints
 * and configuration across the CMS frontend.
 */

// Base API Configuration
export const API_CONFIG = {
  // CMS Backend API (empty = same-origin, used when nginx proxies /api)
  BASE_URL: process.env.REACT_APP_API_BASE_URL ?? '',

  // CMS specific API URL (alias for BASE_URL)
  CMS_URL:
    process.env.REACT_APP_CMS_API_URL ??
    process.env.REACT_APP_API_BASE_URL ??
    '',

  // WhatsApp API URL (empty = same-origin, proxied via nginx)
  WHATSAPP_URL: process.env.REACT_APP_WHATSAPP_API_URL ?? '',

  // Default timeout for API requests
  TIMEOUT: 30000,

  // API Version prefix
  API_PREFIX: '/api',

  // Admin API prefix
  ADMIN_PREFIX: '/api/admin',
};

// Helper to build full API URL
export const buildApiUrl = (path) => {
  const baseUrl = API_CONFIG.BASE_URL;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};

// Helper to build admin API URL
export const buildAdminUrl = (path) => {
  const baseUrl = API_CONFIG.BASE_URL;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${API_CONFIG.ADMIN_PREFIX}${normalizedPath}`;
};

// Helper to build storage URL
export const buildStorageUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const baseUrl = API_CONFIG.BASE_URL;
  const normalizedPath = path.replace(/^\/?storage\/?/, '');
  return `${baseUrl}/storage/${normalizedPath}`;
};

// Helper to build media file URL
export const buildMediaUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const encodedPath = encodeURIComponent(path);
  return `${API_CONFIG.BASE_URL}/api/public/media/serve/${encodedPath}`;
};

// Export default config object
export default API_CONFIG;
